<template>
    <el-dialog :visible.sync="boxVisible" v-if="boxVisible" class="LoadingBox"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true" :show-close="false">
        <div class="message-body">
            <i class='el-icon-loading'></i>
            <p>正在处理中,请稍后...</p>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name:"LoadingBox",
    data() {
        return {
            boxVisible:false
        };
    },
    created() {
    },
    methods:{
        show() {
            this.boxVisible = true;
        },
        close() {
            this.boxVisible = false;
        }
    }
}
</script>

<style lang="less">
.LoadingBox {
    display:flex;
    background-color:rgba(0,0,0,0.8);
    .el-dialog {
        margin-left:10px!important;
        margin-right:10px!important;
        margin-top:auto;
        margin-bottom: auto;
        background: transparent;
        width: 100%;
    }
    .el-dialog__header{
        display:none;
    }
    .el-dialog__body{
        padding:0px;
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
        div.testbg{
            display:none !important;
        }
    }
    .message-body{
        display: flex;
        flex-direction: column;
        padding: 15px 30px;
        margin: auto;
        text-align: center;
        position: relative;
        overflow:auto;
        i{
            color:#bdff00;
            
            font-size:40px;
        }
        p{
            color:#bdff00;
            margin-top: 30px;
            font-size: 18px;
        }
    }
}
</style>
